'use client';

import { useUserInfo } from '../../../helpers/hooks/useUserInfo';
import { handleDepth } from '../../../views/Species/helpers/speciesHelpers';
import { InfoCard } from '../InfoCard/InfoCard';

export const DepthInfoCard = ({
  minCommonDepth,
  maxCommonDepth,
}: {
  minCommonDepth: number;
  maxCommonDepth: number;
}) => {
  const { user } = useUserInfo();

  return (
    <InfoCard title="Common depth" iconText={handleDepth(minCommonDepth, maxCommonDepth, user)} />
  );
};
